<template>
  <div class="business-profile"></div>
</template>

<script>
export default {
  components: {},
  name: 'BusinessProfileFormFields',
  props: {
    profile: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  data: function () {
    return {}
  },
  methods: {},
}
</script>

<style scoped lang="scss"></style>
